"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.reduce.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _badge = _interopRequireDefault(require("antd/lib/badge"));

var _DecoratorsRoot = require("../layout/DecoratorsRoot");

var _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

require("./styles/cartCount.less");

var styles = {
  "root": "meepshop-meep-ui__menu-cartCount__root",
  "wrapper": "meepshop-meep-ui__menu-cartCount__wrapper"
};

var CartCount = (0, _DecoratorsRoot.enhancer)(_class = (_temp = _class2 = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(CartCount, _React$PureComponent);

  var _super = _createSuper(CartCount);

  function CartCount() {
    (0, _classCallCheck2["default"])(this, CartCount);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(CartCount, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          showCartCount = _this$props.showCartCount,
          carts = _this$props.carts,
          children = _this$props.children;
      if (!showCartCount) return children;
      return /*#__PURE__*/_react["default"].createElement(_badge["default"], {
        className: styles.root,
        count: carts.reduce(function (result, _ref) {
          var quantity = _ref.quantity;
          return result + quantity;
        }, 0),
        showZero: false
      }, children);
    }
  }]);
  return CartCount;
}(_react["default"].PureComponent), (0, _defineProperty2["default"])(_class2, "propTypes", {
  /** context */
  carts: _propTypes["default"].array,

  /** props */
  showCartCount: _propTypes["default"].bool.isRequired,
  children: _propTypes["default"].node.isRequired
}), _temp)) || _class;

exports["default"] = CartCount;